import Attack from "./Attacks";
import AirportController from "../airport/AirportController";
import GameController from "../game/GameController";
import AirportModel from "../airport/AirportModel";
import TimeKeeper from "../engine/TimeKeeper";
import {
    cos,
    sin,
} from '../math/core';
import AircraftModel from "../aircraft/AircraftModel";
import AttackController from "./AttackController";
import { ATTACK_SETTING_NAMES } from "../constants/gameAttackConstants";

class PositionAlteringAttack extends Attack {
    /**
     * @param {number} startTimestamp
     */
    constructor(startTimestamp) {
        super(startTimestamp);

        /**
         * Flag to indicate so the aircraft only can jump when it is arriving.
         *
         * @type {boolean}
         * @default false
         * @private
         */
        this.hasMadeJump = false;

        /**
         * The number of jumps nmade by the aircraft.
         *
         * @type {number}
         * @default 0
         * @private
         */
        this.jumps = 0;

        this.init();
    }

    init() {
        super.init();

    }

    /**
     * Updates the attack parameters for the postion altering attack.
     *
     * @param {AircraftModel} aircraftModel
     */
    update(aircraftModel) {

        const maxJumps = AttackController.getAttackOption(ATTACK_SETTING_NAMES.MAXIMUM_OF_JUMPS);

        if (this.jumps >= maxJumps) {
            return;
        }

        if (!this.hasMadeJump && aircraftModel.isControllable && aircraftModel.isAirborne() && Math.floor(TimeKeeper.accumulatedDeltaTime) % 2 == 0) {
            this._calculateJump(aircraftModel);
        } else if (Math.floor(TimeKeeper.accumulatedDeltaTime) % 2 != 0) {
            this.hasMadeJump = false;
        }

    }

    /**
     * @param {number} endTimestamp
     */
    end(endTimestamp) {

        super.end(endTimestamp);
    }

    /**
     * Calulates the jump and applies the new position to the aircraftModel.
     *
     * @param {AirportModel} aircraftModel
     * @private
     */
    _calculateJump(aircraftModel) {
        let prob = AttackController.getAttackOption(ATTACK_SETTING_NAMES.JUMP_PROBABILITY) * 0.005; //This constant is used to make the probability lower.
        if (Math.random() < prob) {                                                                //This will make it less likely for the aircraft to jump.
            this.hasMadeJump = true;
            this.jumps++;
            const jumpRadius = AttackController.getAttackOption(ATTACK_SETTING_NAMES.JUMP_RADIUS);
            const airportCenter = AirportController.airport_get().rangeRings.center;
            const currentPosition = aircraftModel.positionModel.gps;
            const t = 2 * Math.PI * Math.random();
            const u = jumpRadius * (Math.random() + Math.random());
            var r = 0;
            if (u > jumpRadius) {
                r = 2 * jumpRadius - u;
            } else {
                r = u
            }
            const dot = [r * cos(t), r * sin(t)];
            const newPosition = [airportCenter.latitude + dot[0], airportCenter.longitude + dot[1]];
            const movement = [newPosition[0] - currentPosition[0], newPosition[1] - currentPosition[1]];

            // aircraftModel.positionModel.setTrueCoordinates(movement[0], movement[1]);

            //slumpar altituden från 0% till 300% av föregående värde
            aircraftModel.altitude = Math.floor(aircraftModel.altitude * 3 * Math.random());
            if (aircraftModel.altitude >= AirportController.airport_get().ctr_ceiling) {
                aircraftModel.altitude = AirportController.airport_get().ctr_ceiling;
            }
        }
    }
}
export default PositionAlteringAttack;
